// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ratio[data-v-7f3306bd] {\n  border: none !important;\n  background: white;\n}\n.ratio[data-v-7f3306bd]:disabled {\n  opacity: 1 !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
